import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import Scrollbar from "react-perfect-scrollbar";
import { removeFromBasket, setMode } from "../../redux/reducers/basket";
import {
	checkItemAvailabilityChangeBasketMode,
	getRestaurant,
	getServiceTypes,
	getTotalPrice,
	updateBasket,
} from "../../utils/commons";
import { Modal } from "react-bootstrap";
import AlertBasketUpdate from "./AlertBasketUpdate";

const Cartlist = (props) => {
	const basket = useSelector((state) => state.basket);
	const restaurant = useSelector((state) => state.restaurant.restaurant);
	const serviceTypes = getServiceTypes();
	const dispatch = useDispatch();

	// const [basket, setBasket] = useState(getBasket());
	const [basketTotal, setBasketTotal] = useState(getTotalPrice(basket));
	const [showAlert, setShowAlert] = useState(false);
	const [newMode, setNewMode] = useState(basket.mode);
	const deleteItem = (item) => {
		dispatch(removeFromBasket(item));
		setBasketTotal(getTotalPrice(basket));
	};
	useEffect(() => {
		setBasketTotal(getTotalPrice(basket));
	}, [basket.updatedAt]);

	const selectMode = (mode, validate = false) => {
		if (!validate && checkItemAvailabilityChangeBasketMode(mode)) {
			setNewMode(mode);
			setShowAlert(true);
		} else {
			dispatch(
				setMode({
					mode,
					deliveryFees: mode === "delivery" ? restaurant.deliveryFees : 0,
				})
			);

			updateBasket(mode);
		}
	};

	return (
		<Fragment>
			<div className="cart-sidebar-body">
				<Scrollbar className="cart-sidebar-scroll" style={{ height: "65vh" }}>
					<div className="row">
						<div className="col-sm-12 col-12">
							<div
								className="row services-button-container"
								style={{ justifyContent: "flex-start", padding: "0 0 0 15px" }}
							>
								{serviceTypes.includes("takeAway") && (
									<div className="form-group">
										<button
											type="button"
											className={
												"btn-custom btn-service shadow-none btn-sm " +
												(basket.mode != "takeAway" ? "light" : "")
											}
											onClick={() => {
												selectMode("takeAway");
											}}
										>
											A emporter
										</button>
									</div>
								)}
								{serviceTypes.includes("onSite") && (
									<div className="form-group">
										<button
											type="button"
											className={
												"btn-custom btn-service shadow-none btn-sm " +
												(basket.mode != "onSite" ? "light" : "")
											}
											onClick={() => {
												selectMode("onSite");
											}}
										>
											Sur place
										</button>
									</div>
								)}
								{serviceTypes.includes("delivery") && (
									<div className="form-group">
										<button
											type="button"
											className={
												"btn-custom btn-service shadow-none btn-sm " +
												(basket.mode != "delivery" ? "light" : "")
											}
											disabled={
												!restaurant ||
												!restaurant.deliveryEnabled ||
												basketTotal <= parseFloat(restaurant.minAmountDelivery)
											}
											onClick={() => selectMode("delivery")}
										>
											En Livraison
										</button>
										{!!restaurant && !restaurant.deliveryEnabled ? (
											<div className="text-center">
												<span className="fs-14" style={{}}>
													Non disponible
												</span>
											</div>
										) : !!restaurant &&
										  basketTotal <=
												parseFloat(restaurant.minAmountDelivery) ? (
											<div className="text-center">
												<span className="fs-14" style={{}}>
													Min. {restaurant.minAmountDelivery} €
												</span>
											</div>
										) : null}
									</div>
								)}
							</div>
						</div>
					</div>

					{basket.items.map((item, i) => (
						<div key={i} className="cart-sidebar-item">
							<div className="media">
								<img src={item.image} alt={item.name} />
								<div className="media-body">
									<h5>{item.name}</h5>
									<span>
										{item.quantity || 1}x {parseFloat(item.price).toFixed(2)} €
									</span>
								</div>
							</div>
							<div className="cart-sidebar-item-meta">
								{item.selectedItems ? (
									item.selectedItems
										// .sort((a, b) => a.order - b.order)
										.map((sItem, i) => (
											<React.Fragment key={i}>
												<span>{sItem.name}</span>
												{sItem.selectedOptions
													? sItem.selectedOptions
															// .sort((a, b) => b.order - a.order)
															.map((sOpt, iO) => (
																<span key={iO}>
																	&nbsp;&nbsp;&nbsp;
																	{sOpt.name}
																	{sOpt.quantity > 1 && " x" + sOpt.quantity}
																</span>
															))
													: null}
											</React.Fragment>
										))
								) : (
									<span>&nbsp;</span>
								)}
								{item.selectedOptions ? (
									item.selectedOptions.map((sItem, i) => (
										<span key={i}>
											{sItem.name}
											{sItem.quantity > 1 && " x" + sItem.quantity}
										</span>
									))
								) : (
									<span>&nbsp;</span>
								)}
							</div>
							<div className="cart-sidebar-price">
								{(parseFloat(item.price) * (item.quantity || 1)).toFixed(2)} €
							</div>
							<div className="close-btn" onClick={() => deleteItem(item)}>
								<span />
								<span />
							</div>
						</div>
					))}
				</Scrollbar>
			</div>
			<div className="cart-sidebar-footer">
				<h4>
					TOTAL : <span>{basketTotal.toFixed(2)} €</span>{" "}
				</h4>
				{basket.items.length > 0 && (
					<Link to={"/checkout"}>
						<button
							type="button"
							className="btn-custom"
							disabled={basket.items.length === 0}
							onClick={() => props.closeCartList(1)}
						>
							VALIDER LA COMMANDE
						</button>
					</Link>
				)}
			</div>
			{showAlert == true && (
				<Modal
					show={showAlert}
					id="alertModeModal"
					aria-labelledby="contained-modal-title-vcenter"
					size="lg"
					centered
				>
					<AlertBasketUpdate
						mode={newMode}
						onValidate={() => {
							selectMode(newMode, true);
							setShowAlert(false);
						}}
						onHide={() => {
							setShowAlert(false);
						}}
					/>
				</Modal>
			)}
		</Fragment>
	);
};

export default Cartlist;
